
import styles from './Terms.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';


function Terms() {

    return (
        <>
            <div className="temp_bg">
                <span>이용약관</span>
            </div>
            <div className="components_wrap">
                <span className='components_wrap_title'>이용약관</span>
                <div className={styles.terms_cont} dangerouslySetInnerHTML={{
                            __html: `
### 제 1 장 총칙

### 제 1 조 (목적)

이 약관은 한국공학한림원 차세대공학리더(’www.naekyehs.org’, 이하 YEHS)에서 제공하는 서비스를 이용함에 있어 YEHS와 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 한다.

### 제 2 조 (용어의 정의)

① 회원 : YEHS와 서비스 이용 계약을 체결하여 이용자 ID를 부여 받은 개인을 지칭한다.

② 이용자 : YEHS 서비스를 이용하는 개인 또는 기업을 지칭한다.

③ 패스워드 : 이용자의 실명을 확인하기 위한 암호를 지칭한다.

④ ID(아이디) : 이용자를 구분하기 위한 것으로 YEHS가 개별적으로 부여하는 번호를 지칭한다.

### 제 3 조 (약관의 효력과 변경)

① 약관은 이용자에게 공시하고 동의를 받음으로써 효력이 발생한다.

② YEHS는 사정 변경의 경우와 영업상의 중요한 사유가 있을 경우 약관을 변경할 수 있으며, 변경된 약관은 이용자에게 공시함으로써 효력이 발생한다.

③ 이 약관은 2024년 12월 1일부터 시행한다.

④이 약관에 명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 그 규정에 따르도록 한다.

### 제 4 조 (약관의 공시 및 준용)

① 이 약관의 내용은 서비스 화면에 게시하여 공시하며, 약관이 변경 될 경우 YEHS는 이 약관을 공지 사항에 공시 한다.

② YEHS는 이용약관의 변경 전이라도 이용자에게 중대한 영향을 미치는 사항에 대해서는 공지 사항을 통해서 공지 할 수 있으며, 이는 약관의 일부로서 유효하다.

③ 3조 1항, 2항 및 4조 1항, 2항의 규정과는 별도로 법령에 의해 개별적인 통보 및 동의가 필요한 경우에는 그 절차에 따른다.

### 제 2 장 이용

### 제 5 조 (서비스의 이용)

① 이 약관의 내용은 서비스 화면에 게시하여 공시하며, 약관이 변경 될 경우 YEHS는 이 약관을 공지 사항에 공시 한다.

② 본 약관에 명시되지 않은 서비스 이용에 관한 사항은 YEHS가 정하여 서비스 안내에 게시하거나 또는 별도로 공지하는 내용에 따른다.

### 제 6 조 (YEHS의 의무)

① YEHS는 지속적으로 안정적인 서비스를 제공할 의무가 있다.

② YEHS는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될 경우에는 정해진 절차에 따라서 즉시 처리 하여야 한다.

(단, 즉시 처리가 곤란한 경우에는 이용자에게 그 사유와 처리 일정을 통보하여야 한다.)

③ YEHS는 서비스의 제공과 관련하여 이용자의 신상 정보를 본인의 승낙 없이 타인에게 누설, 배포하여서는 안 된다.

④ 제3항의 경우 전기 통신 관계 법령 등에 의하여 국가 기관의 요구가 있는 경우나, 수사상의 목적으로 영장의 제시가 있는 경우에는 그러하지 아니하다.

### 제 7 조 (회원의 의무)

① 이용자는 제1항 외에도 이 약관 및 YEHS의 공지사항, 서비스별 이용 안내 사항을 숙지하고 준수하여야 한다.

② 회원은 본 서비스를 건전한 컨설팅 이외의 목적으로 이용해서는 안 된다.

③ 회원은 자료내용을 사실에 근거하여 성실하게 작성해야 한다. 허위 또는 부정확한 자료로 인해 발생하는 모든 책임은 회원에게 있다.

④ 아이디와 비밀번호에 관한 모든 관리의 책임은 이용자에게 귀속된다.

### 제 8 조 (게시물 관리)

YEHS는 건전한 통신문화정착과 효율적인 서비스 운영을 위하여 이용자가 게시하거나 제공하는 자료가 다음 각 호의 1에 해당한다고 판단되는 경우에 임의로 삭제, 자료이동, 등록거부를 할 수 있다.

① 제 3자 또는 YEHS의 명예, 신용을 훼손하거나 오용하는 내용 또는 영업을 방해하는 내용인 경우

② 범죄적 행위화 결부된다고 객관적으로 인정되는 내용인 경우

③ 제3자 또는 YEHS의 지적재산권 등 권리를 침해하는 내용인 경우

④ YEHS에서 규정한 게재기간을 초과한 경우

⑤ 기타 관계법령 및 YEHS의 게시물 관리 규정에 위배된다고 판단되는 경우

### 제 9 조 (서비스 이용의 제한)

이용자의 서비스 이용 내용 및 행위가 다음 각 호의 1에 해당하는 경우, YEHS는 이용 제한을 할 수 있다.

① 공공질서 및 미풍양속에 반하는 경우

② 범죄적 행위에 관련되는 경우

③ 타인의 명예를 손상시키거나 타인의 서비스 이용을 현저히 저해하는 경우

④ 서비스에 위해를 가하거나 바이러스 감염자료 게재 등으로 서비스의 건전한 운영을 저해하는 경우

⑤ 다른 이용자 또는 제3자의 지적재산권을 침해하거나 지적재산권자가 지적 재산권의 침해를 주장할 수 있다고 판단되는 경우

⑥ 타인의 이용자번호 및 비밀번호를 도용한 경우

⑦ 관계법령에 위배되는 경우

⑧ 컨설팅 관련 정보 이외의 목적으로 등록하여 YEHS에 피해를 주었을 경우

⑨ 이용 계약 신청서의 내용을 허위로 기재하거나 허위 서류를 첨부하여 신청한 경우

⑩ 기타 YEHS가 이용자로서 부적당하다고 판단하는 경우

### 제 10 조 (서비스 제공의 중지)

YEHS는 다음 각 호의 1에 해당하는 경우 서비스의 전부 또는 일부의 제공을 중지할 수 있다.

① 전기통신사업법상에 규정된 기간통신 사업자 또는 상위의 인터넷 망 사업자가 서비스를 중지했을 경우

② 정전으로 서비스 제공이 불가능할 경우

③ 서비스용 설비의 이전, 보수 또는 공사로 인하여 부득이한 경우

④ 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 어려운 경우

### 제2장 면책조항

### 제 11 조 (면책조항)

① 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 YEHS의 서비스 제공 책임이 면제된다.

② YEHS는 이용자들의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않는다.

③ 이용자가 YEHS의 서비스 제공으로부터 기대되는 이익을 얻지 못할 경우 및 서비스 자료에 대한 취사선택, 이용으로부터 발생되는 손익에 대하여 YEHS는 책임을 지지 않는다.

④ YEHS는 이용자가 게시 또는 전송한 자료의 내용에 관하여는 책임을 지지 않는다.

### 제4장 계약

### 제 12 조 (계약의 성립)

① YEHS는 아래와 같은 구매신청에 대하여 다음 각 호에 해당하지 않는 한 승낙한다.

1. 신청 내용에 허위, 기재누락, 오기가 있는 경우

2. 기타 구매신청에 승낙하는 것이 YEHS의 기술상 현저히 지장이 있다고 판단하는 경우

② YEHS의 승낙이 수신확인 통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 본다.

### 제 13 조 (지급방법)

①YEHS에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의 하나로 할 수 있다. 단, 이의 운영방식은 회사가 정한 바에 의한다.

1. 신용카드결제

2. 온라인 무통장입금
`}} />
            </div>
        </>
    );
}

export default Terms;